<header class="mobile-header">
  <div class="mobile-header__container">
    <button
      data-testid="mobile-menu-button"
      type="button"
      class="mobile-header__menu-button"
      [attr.aria-label]="'App.RecordSelector' | translate"
      (click)="goToRecordSelector()"
      (keyup.enter)="goToRecordSelector()">
      <icon-display [iconName]="isOnlyClient ? 'document-text' : 'menu'" />
    </button>
    <div class="mobile-header__right-section">
      @if (hasNotifications) {
        <button
          type="button"
          class="mobile-header__notification-button"
          [attr.aria-label]="'App.Notifications' | translate"
          (click)="openNotifications()"
          (keyup.enter)="openNotifications()">
          <icon-display iconName="bell" />
          @if (hasNotifications) {
            <div class="mobile-header__notification-button__dot"></div>
          }
        </button>
      }

      <lwty-button-icon
        data-testid="mobile-faq-button"
        theme="minimal"
        [icon]="'help-circle'"
        [ariaLabel]="'App.Faqs' | translate"
        (click)="goToFaqs()"
        (keyup.enter)="goToFaqs()" />

      <button
        data-testid="btn-mobile-settings"
        type="button"
        class="mobile-header__message-button"
        [attr.aria-label]="'App.Settings' | translate"
        (click)="goToProfile()"
        (keyup.enter)="goToProfile()">
        <icon-display iconName="cog" />
      </button>
    </div>
  </div>

  @if (notificationsOpen) {
    <lc-notifications-panel
      [notifications]="notifications"
      (closePanelEvent)="closeNotifications()"
      (markNotificationAsReadEvent)="markNotificationAsRead($event)" />
  }
</header>

<app-mobile-menu
  [isOpen]="mobileMenuOpen"
  [menuItems]="menuItems"
  (closeMenu)="onMobileMenuClose()" />
